export enum Tenants {
  ANEF = 'anef',
  ANEF_SUMMER = 'anef~summer',
  APRICA = 'aprica',
  BARDO = 'bardonecchia',
  BARDO_SUMMER = 'bardonecchia~summer',
  BENEFICY = 'beneficy',
  BENEFICY_BIKEIT = 'beneficy-bikeit',
  BENEFICY_DISCOVERA = 'beneficy-discovera',
  BENEFICY_SNOWIT = 'beneficy-snowit',
  BIKEIT = 'bikeit',
  BOBBIO = 'pianidibobbio',
  BOBBIO_B2B = 'pianidibobbio-b2b',
  BOBBIO_SUMMER = 'pianidibobbio~summer',
  BOLONICE = 'bolonice',
  BORMIO = 'bormioski',
  BORMIO_SUMMER = 'bormioski~summer',
  CERVINO_SKI = 'cervino-ski-paradise',
  CERVINO_SKI_B2B = 'cervino-ski-paradise-b2b',
  CIMONE = 'cimone',
  CORNO = 'cornoallescale',
  CORNO_SUMMER = 'cornoallescale~summer',
  CORTINA = 'cortina',
  COURMAYEUR = 'courmayeur',
  DEMO = 'demo',
  DEMO_B2B = 'demo-b2b',
  DISCOVERA = 'discovera',
  DOVESCIARE = 'dovesciare',
  EDENRED = 'edenred',
  ENDUROREPUBLIC = 'endurorepublic-tribala',
  ENDUROREPUBLIC_HOTEL = 'endurorepublic-hotel',
  FOLGARIA = 'folgaria',
  GAZZETTA_BIKEIT = 'ciclista',
  GAZZETTA_TRIBALA = 'gazzettaadventure',
  GETYOURGUIDE = 'getyourguide',
  GITE_IN_TRENO = 'giteintreno',
  GKS = 'gks',
  HAPPYRENTALS = 'happyrental',
  JAKALA_DISCOVERA = 'jakala-discovera',
  JAKALA_SNOWIT = 'jakala-snowit',
  JOINTLY = 'jointly',
  JOINTLY_DISCOVERA = 'jointly-discovera',
  KITEREVOLUTION = 'kiterevolution',
  KTS = 'kts',
  LIVIGNO = 'livigno',
  LIVIGNO_B2B = 'livigno-b2b',
  LIVIGNO_SUMMER = 'livigno~summer',
  LOMBARDIA = 'skipasslombardia',
  MADONNA_B2B = 'madonnadicampiglio-b2b',
  MADONNA_B2B_AGENZIE = 'madonnadicampiglio-b2b-agenzie',
  MADONNA_CC1 = 'mdc-cambiomerce1',
  MADONNA_CC2 = 'mdc-cambiomerce2',
  MADONNA_COUPON = 'mdc-coupon',
  MADONNA_GRUPPI = 'madonnadicampiglio-gruppi',
  MANGACLIMBING = 'mangaclimbing-tribala',
  MC4 = 'mc4season',
  PADEL4FUN = 'padel4fun',
  PADEL_ACADEMY = 'padelacademy',
  PAGANELLA = 'paganella',
  PONTE = 'adamello-ski',
  PONTE_B2B = 'adamello-ski-b2b',
  PONTE_SUMMER = 'adamello-ski~summer',
  SANTA = 'santacaterina',
  SANTA_SUMMER = 'santacaterina~summer',
  SKIFUN = 'skifun',
  SNOWIT = 'snowit',
  SNOWIT_EN = 'snowit-en',
  SNOWIT_EUROPE = 'snowit-europe',
  SNOWIT_TRAVEL = 'snowit-travel',
  SPORTMISSION = 'sportmission',
  SVAGO = 'tantosvago',
  SVAGO_BIKEIT = 'tantosvago-bikeit',
  SVAGO_SUMMER = 'tantosvago~summer',
  SVAGO_TRIBALA = 'tantosvago-tribala',
  TRIBALA = 'tribala',
  UNIPOL = 'unipol',
  UNIVERSITYBOX = 'universitybox',
  XTREMELEMENT = 'xtremelement',
}

export const MAIN_TENANTS: Tenants[] = [
  Tenants.SNOWIT,
  Tenants.TRIBALA,
  Tenants.BIKEIT,
  Tenants.DISCOVERA,
];

export const SSR_INDEX: Tenants[] = [
  ...MAIN_TENANTS,
  Tenants.GITE_IN_TRENO,
  Tenants.GAZZETTA_BIKEIT,
  Tenants.CERVINO_SKI,
];
